export class MedidasProducto {

  medidaProducto: string;
  medidaPackaging: string;
  volumen: string;
  peso: string;
  unidades: number;

}



// WEBPACK FOOTER //
// ./src/app/productos/medidas-producto.model.ts